module.exports = __webpack_public_path__ + "static/media/soh.f6b5c375.PNG";